/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ApiKey } from '../models/api-key';
@Injectable({
  providedIn: 'root',
})
class ApiKeysService extends __BaseService {
  static readonly ApiKeysGetAllPath = '/api/ApiKeys/GetAll';
  static readonly ApiKeysRevealKeyPath = '/api/ApiKeys/Reveal';
  static readonly ApiKeysPostPath = '/api/ApiKeys/AddKey';
  static readonly ApiKeysDeletePath = '/api/ApiKeys/DeleteKey';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }
  ApiKeysGetAllResponse(): __Observable<__StrictHttpResponse<Array<ApiKey>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/ApiKeys/GetAll`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ApiKey>>;
      })
    );
  }  ApiKeysGetAll(): __Observable<Array<ApiKey>> {
    return this.ApiKeysGetAllResponse().pipe(
      __map(_r => _r.body as Array<ApiKey>)
    );
  }

  /**
   * @param keyId undefined
   */
  ApiKeysRevealKeyResponse(keyId?: number): __Observable<__StrictHttpResponse<ApiKey>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (keyId != null) __params = __params.set('keyId', keyId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/ApiKeys/Reveal`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ApiKey>;
      })
    );
  }
  /**
   * @param keyId undefined
   */
  ApiKeysRevealKey(keyId?: number): __Observable<ApiKey> {
    return this.ApiKeysRevealKeyResponse(keyId).pipe(
      __map(_r => _r.body as ApiKey)
    );
  }

  /**
   * @param newkey undefined
   */
  ApiKeysPostResponse(newkey: ApiKey): __Observable<__StrictHttpResponse<ApiKey>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = newkey;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/ApiKeys/AddKey`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ApiKey>;
      })
    );
  }
  /**
   * @param newkey undefined
   */
  ApiKeysPost(newkey: ApiKey): __Observable<ApiKey> {
    return this.ApiKeysPostResponse(newkey).pipe(
      __map(_r => _r.body as ApiKey)
    );
  }

  /**
   * @param apiKeyId undefined
   */
  ApiKeysDeleteResponse(apiKeyId?: number): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (apiKeyId != null) __params = __params.set('apiKeyId', apiKeyId.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/ApiKeys/DeleteKey`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param apiKeyId undefined
   */
  ApiKeysDelete(apiKeyId?: number): __Observable<Blob> {
    return this.ApiKeysDeleteResponse(apiKeyId).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module ApiKeysService {
}

export { ApiKeysService }
